'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveModals = exports.pathSelector = exports.modalDispatcher = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reducers;

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var reducers = (_reducers = {}, (0, _defineProperty3['default'])(_reducers, _actions.ACTIVATE_MODAL, function (state, modalId) {
  return (0, _assign2['default'])({}, state, (0, _defineProperty3['default'])({}, modalId, true));
}), (0, _defineProperty3['default'])(_reducers, _actions.DEACTIVATE_MODAL, function (state, modalId) {
  return (0, _assign2['default'])({}, state, (0, _defineProperty3['default'])({}, modalId, false));
}), _reducers);

var callReducer = function callReducer(reducer, state, action) {
  return reducer ? reducer(state, action) : state;
};

var modalDispatcher = exports.modalDispatcher = function modalDispatcher() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      modalId = _ref.modalId;
  return callReducer(reducers[type], state, modalId);
};

var parent = function parent(state) {
  return state;
};
var attachTo = function attachTo(newParent) {
  parent = newParent;
};

var pathSelector = exports.pathSelector = (0, _assign2['default'])(function (state) {
  return parent(state).modalDispatcher;
}, attachTo);

var getActiveModals = exports.getActiveModals = pathSelector;

exports['default'] = { modalDispatcher: modalDispatcher };